import React from 'react';
export const LemanaProLogoDefault = () => (/*#__PURE__*/React.createElement("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.1247 6.17859L16.9501 12.19L20.7269 15.9211V21.7547H12.6301L11.2715 27.9992H28V12.9766L21.1247 6.17859Z",
  fill: "var(--logo-right-form-color)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9991 11.2466L21.1246 6.17859L16.9485 12.1853L15.9991 11.2466Z",
  fill: "var(--logo-angles-form-color)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.2715 21.7534V27.9979L12.6304 21.7534H11.2715Z",
  fill: "var(--logo-angles-form-color)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.0009 1.10999L4 12.976V27.9984H11.2733V21.7539V15.9202L16.0009 11.2457L21.1263 6.17795L16.0009 1.10999Z",
  fill: "var(--logo-pro-letters-color)"
})));